const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_Ef3NW4kIR",
  ClientId: "305o0k1o6c6m1es1irkgef43k6"
}
export default awsConfiguration
